import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { SHOW_GLOBAL_LOADER } from '@shared/data-access/data-access-ui';
import { isDefined } from '@shared/utils/is-defined.utils';
import { Observable } from 'rxjs';
import { FilterTrainingDataRequest } from '../models/filter-training-data-request.model';
import { TrainingDataItem } from '../models/training-data-item.model';

@Injectable()
export class AiKnowledgeService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  getTrainingData(payload: FilterTrainingDataRequest): Observable<TrainingDataItem[]> {
    let params = new HttpParams();

    if (isDefined(payload.pageNumber)) {
      params = params.set('pageNumber', payload.pageNumber);
    }

    if (payload.pageSize) {
      params = params.set('pageSize', payload.pageSize);
    }

    return this.http.get<TrainingDataItem[]>(`${this.baseUrl}/v1/machinelearning/training-data`, {
      params,
      context: new HttpContext().set(SHOW_GLOBAL_LOADER, payload.enableGlobalLoader),
    });
  }

  downloadTemplate() {
    return this.http.get(`${this.baseUrl}/v1/machinelearning/training-data/template`, {
      context: new HttpContext().set(SHOW_GLOBAL_LOADER, true),
      responseType: 'blob',
      observe: 'response',
    });
  }

  uploadCsv(file: File): Observable<void> {
    const formData = new FormData();

    formData.append('file', file);

    return this.http.post<void>(`${this.baseUrl}/v1/machinelearning/training-data/upload-csv`, formData, {
      context: new HttpContext().set(SHOW_GLOBAL_LOADER, true),
    });
  }
}
